import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import {
  IDashboardStat,
  IDashboardActivity,
  IDashboardMetric,
  IDashboardConfig,
} from '../types/interfaces/IDashboard';

const DEFAULT_METRICS = [
  'attended_appointments',
  'absenteeism_rate',
  'new_patients',
  'cancellation_rate',
];

const METRIC_LABELS: Record<string, string> = {
  attended_appointments: 'Turnos atendidos',
  absenteeism_rate: 'Tasa de ausentismo',
  cancellation_rate: 'Tasa de cancelacion',
  new_patients: 'Pacientes nuevos',
  peak_hours: 'Horas pico',
  overbooked_count: 'Sobreturnos',
  top_diagnoses: 'Diagnosticos frecuentes',
  recurring_patients: 'Pacientes recurrentes',
  avg_consultation_time: 'Tiempo promedio de consulta',
  referrals_count: 'Derivaciones realizadas',
};

const METRIC_ICONS: Record<string, string> = {
  attended_appointments: 'event',
  absenteeism_rate: 'trending_up',
  cancellation_rate: 'notifications',
  new_patients: 'people',
  peak_hours: 'trending_up',
  overbooked_count: 'notifications',
  top_diagnoses: 'description',
  recurring_patients: 'medical_services',
  avg_consultation_time: 'event',
  referrals_count: 'category',
};

const METRIC_COLORS: string[] = ['#7c3aed', '#c026d3', '#0288d1', '#16a34a', '#d97706', '#dc2626'];

function mapMetricToLegacyStat(metric: IDashboardMetric, index: number): IDashboardStat {
  return {
    id: metric.key,
    title: METRIC_LABELS[metric.key] || metric.name,
    value: metric.value,
    icon: METRIC_ICONS[metric.key] || 'trending_up',
    color: METRIC_COLORS[index % METRIC_COLORS.length],
    trend: 'Periodo actual',
  };
}

export async function getDashboardMetrics(
  period: 'day' | 'week' | 'month' | 'year' = 'week',
  metrics: string[] = DEFAULT_METRICS
): Promise<ApiResponse<IDashboardMetric[]>> {
  const params = new URLSearchParams({
    period,
    metrics: metrics.join(','),
  });

  return apiClient.get<IDashboardMetric[]>(`/dashboard/metrics?${params.toString()}`);
}

export async function getDashboardConfig(): Promise<ApiResponse<IDashboardConfig>> {
  return apiClient.get<IDashboardConfig>('/dashboard/config');
}

export async function updateDashboardConfig(
  selectedMetrics: string[]
): Promise<ApiResponse<IDashboardConfig>> {
  return apiClient.put<IDashboardConfig>('/dashboard/config', {
    selectedMetrics,
  });
}

export async function getDashboardStats(
  _userId: string,
  _userRole: string
): Promise<ApiResponse<IDashboardStat[]>> {
  const metricsResponse = await getDashboardMetrics('week', DEFAULT_METRICS);
  if (!metricsResponse.success) {
    return {
      ...metricsResponse,
      data: [],
    } as ApiResponse<IDashboardStat[]>;
  }

  const mapped = metricsResponse.data.map(mapMetricToLegacyStat);
  return {
    ...metricsResponse,
    data: mapped,
  };
}

export async function getDashboardActivity(
  _userId: string,
  _userRole: string,
  _specialty?: string
): Promise<ApiResponse<IDashboardActivity[]>> {
  return {
    success: true,
    data: [],
    status: 200,
  };
}
